import { VHSize } from '../../utils/browser/css/types';

export const DEFAULT_COMBOBOX_POPOVER_MAX_HEIGHT: VHSize = '80vh';
